import { useState } from 'react'
import { FiUser, FiCalendar } from 'react-icons/fi'
import { FaMoneyBillWave, FaCartShopping } from 'react-icons/fa6'
import { FaFileInvoiceDollar, FaList, FaSitemap, FaChartLine } from 'react-icons/fa'

import Modal from '../../../shared/modal/Modal'
import NewInvoice from '../../fiscal/NewInvoice'
import ProductionReportIcon from '../../../shared/components/ProductionReportIcon/ProductionReportIcon'

import './ListOrderRow.css'

/* Hooks */
import TimestampToString from '../../../shared/functions/TimestampToString'
import buildPurchaseSummary from '../../../shared/functions/buildPurchaseSummary'

// Lista somente leitura — ações de edição/etapa chegam junto com a tela de acompanhamento de produção do roadmap.
function ListOrderRow({ dataArray, myPermissionView, myPermissionFiscalCreate, myPermissionProductionView, myPermissionPurchaseView, myPermissionViewMargin }) {

    const { timeStampToDDMMAAAA } = TimestampToString()
    const [modalSummary, setModalSummary] = useState(false)
    const [summaryItem, setSummaryItem] = useState(null)
    const [modalNewInvoice, setModalNewInvoice] = useState(false)
    const [invoiceOrderItem, setInvoiceOrderItem] = useState(null)

    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                <div key={item._id} className='pg-item'>
                    <div className='pg-item-main'>
                        <div className='order-row-text'>
                            <div className='order-row-header'>
                                <span className='order-row-code'>#{item.code}</span>
                                <span className='order-row-name'>{item.client?.name}</span>
                            </div>
                            <div className='order-row-links'>
                                {item.orderEntryDate && (
                                    <span className='order-row-link-item'><FiCalendar size={11} />{timeStampToDDMMAAAA(item.orderEntryDate)}</span>
                                )}
                                {item.seller?.name && (
                                    <span className='order-row-link-item'><FiUser size={11} />{item.seller.name}</span>
                                )}
                                {item.orderPrice && (
                                    <span className='order-row-price'><FaMoneyBillWave size={11} />R$ {item.orderPrice}</span>
                                )}
                            </div>
                        </div>
                    </div>

                    {(item.step || item.status) && (
                        <div className='order-row-step-col'>
                            <span className='order-row-step-caption'>{item.nature === 'order' ? 'Pedido' : item.nature}</span>
                            <div className='order-row-step-badges'>
                                {item.step && <span className='order-row-step-badge'>{item.step}</span>}
                                {item.status && <span className='order-row-status-badge'>{item.status}</span>}
                            </div>
                        </div>
                    )}

                    <div className='shd-row-box-item-action'>
                        {myPermissionPurchaseView && (
                            <div className='order-icon-summary-wrap' title='Resumo de Compra' onClick={() => { setSummaryItem(item); setModalSummary(true) }}>
                                <FaCartShopping className='order-icon-summary-cart' />
                                <FaList className='order-icon-summary-badge' />
                            </div>
                        )}
                        {myPermissionProductionView && (
                            <ProductionReportIcon title='Relatório de Produção' onClick={() => window.open(`/order/report/${item._id}`, '_blank')} />
                        )}
                        {myPermissionProductionView && (
                            <FaSitemap className='order-icon-row-tree' title='Árvore de Produção' onClick={() => window.open(`/order/production-tree/${item._id}`, '_blank')} />
                        )}
                        {myPermissionViewMargin && (
                            <FaChartLine className='order-icon-row-margin' title='Ver Lucro / Margem' onClick={() => window.open(`/order/margin/${item._id}`, '_blank')} />
                        )}
                        {myPermissionFiscalCreate && (
                            <FaFileInvoiceDollar className='order-icon-row-fiscal' title='Emitir Nota Fiscal' onClick={() => { setInvoiceOrderItem(item); setModalNewInvoice(true) }} />
                        )}
                    </div>
                </div>
            ))
        }
    }

    const summary = summaryItem ? buildPurchaseSummary(summaryItem) : []

    return (
        <div>
            {listArray()}

            <Modal
                modalStatus={modalSummary}
                changeStatus={setModalSummary}
                w={50}
                content={
                    <div className="order-summary">
                        <div className="order-summary-header">
                            <p className="order-summary-title">Resumo de Compra {summaryItem && `— #${summaryItem.code}`}</p>
                            <span className="order-summary-title-accent" />
                            <p className="order-summary-subtitle">Necessidade bruta de tecido e aviamento para este pedido (não desconta o estoque atual).</p>
                        </div>
                        {summary.length > 0 ? (
                            <div className="order-summary-list">
                                {summary.map((g, i) => (
                                    <div key={i} className="order-summary-item">
                                        <div className="order-summary-item-text">
                                            {g.type === 'aviamento' ? (
                                                <span className="order-summary-cloth">{g.aviamentoName} <span className="order-summary-color">— Aviamento</span></span>
                                            ) : (
                                                <span className="order-summary-cloth">{g.clothName} <span className="order-summary-color">— {g.colorLabel}</span></span>
                                            )}
                                            {g.providerName && <span className="order-summary-provider">{g.providerName}</span>}
                                        </div>
                                        <span className="order-summary-qty">{g.total.toFixed(2)} {g.unitLabel}</span>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className="order-summary-empty">Nenhum item com consumo de tecido ou aviamento neste pedido.</p>
                        )}
                    </div>
                }
            />

            <Modal
                modalStatus={modalNewInvoice}
                changeStatus={setModalNewInvoice}
                t={1}
                w={98}
                h={97}
                content={
                    invoiceOrderItem && (
                        <NewInvoice
                            orderId={invoiceOrderItem._id}
                            btCancelAction={() => setModalNewInvoice(false)}
                            handleOnSuccess={() => setModalNewInvoice(false)}
                        />
                    )
                }
            />
        </div>
    )
}

export default ListOrderRow
